import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { TradeAdminRoutingModule } from '../../tradeAdmin-routing.module';
import { EnitComplainceRoutingModule } from '../../eComplaince-routing.module'
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SharedModule } from '../../../../shared/shared.module'
import { CtclModule } from '../../EnitTrade/ctcl/ctcl.module';

import { AgGridModule } from 'ag-grid-angular';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { HighchartsChartModule } from 'highcharts-angular';
import { InternalAuditRegistrationReportComponent } from './auditor-registration-report-component/internal-auditor-registration-report-component';
import { BeforeinternaldtlsComponent } from './beforeinternaldtls/beforeinternaldtls.component';
import { CellAtrInternalRendererComponent } from './cell-atr-internal-renderer/cell-atr-internal-renderer.component';
import { CellAtrRendererComponent } from './cell-atr-renderer/cell-atr-renderer.component';
import { InternalAdminMISReportComponent } from './internal-admin-misreport/internal-admin-misreport.component';
import { InternalAdminSetupComponent } from './internal-admin-setup/internal-admin-setup.component';
import { InternalAuditComponent } from './internal-audit/internal-audit.component';
import { InternalAuditApproveRejectComponent } from './internal-audit-approve-reject/internal-audit-approve-reject.component';
import { InternalAuditATRReportComponent } from './internal-audit-atrreport/internal-audit-atrreport.component';
import { InternalAuditEligibleUsersComponent } from './internal-audit-eligible-users/internal-audit-eligible-users.component';
import { InternalAuditFollowOnExchangeActionComponent } from './internal-audit-follow-on-exchange-action/internal-audit-follow-on-exchange-action.component';
import { InternalAuditFollowOnSubmissionComponent } from './internal-audit-follow-on-submission/internal-audit-follow-on-submission.component';
import { InternalAuditHeaderEditComponent } from './internal-audit-header-edit/internal-audit-header-edit.component';
import { InternalAuditMISReportComponent } from './internal-audit-misreport/internal-audit-misreport.component';
import { InternalAuditTORBuildingComponentComponent } from './internal-audit-torbuilding-component/internal-audit-torbuilding-component.component';
import { InternalAuditTORPreviewComponent } from './internal-audit-torpreview/internal-audit-torpreview.component';
import { InternalAuditorMISComponent } from './internal-auditor-mis/internal-auditor-mis.component';
import { InternalTorBuilderComponent } from './internal-tor-builder/internal-tor-builder.component';
import { InternalAuditorRegistrationReportComponent } from './internal-auditor-registration-report/internal-auditor-registration-report.component';
import { CellInternalRendererComponent } from './cell-internal-renderer/cell-internal-renderer.component';
import { AddInternalAuditUsersComponent } from './add-internal-audit-users/add-internal-audit-users.component';




@NgModule({
  declarations: [
    InternalAuditRegistrationReportComponent,
    BeforeinternaldtlsComponent,
    CellAtrInternalRendererComponent,
    CellAtrRendererComponent,
    AddInternalAuditUsersComponent,
    InternalAdminMISReportComponent,

    InternalAdminSetupComponent,
    InternalAuditComponent,
    InternalAuditApproveRejectComponent,

    InternalAuditATRReportComponent,
    InternalAuditEligibleUsersComponent,
    CellInternalRendererComponent,
    InternalAuditFollowOnExchangeActionComponent,
    InternalAuditFollowOnSubmissionComponent,
    InternalAuditHeaderEditComponent,
    InternalAuditMISReportComponent,
    InternalAuditTORBuildingComponentComponent,
    InternalAuditTORPreviewComponent,
    InternalAuditorMISComponent,
    InternalAuditorRegistrationReportComponent,
    InternalTorBuilderComponent,



  ],
  imports: [

    CommonModule,
    TradeAdminRoutingModule,
    FormsModule,
    DataTablesModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    BsDatepickerModule,
    SharedModule,
    CtclModule,
    EnitComplainceRoutingModule,
    AgGridModule,
    BaseChartDirective,
    HighchartsChartModule
  ]
})
export class InternalAuditModule { }
